import Component from "vue-class-component";
import BasketAbstract from "@/components/BasketAbstract/BasketAbstract";
import { Manager, Client } from "@/api/profile";
import { Getter } from "vuex-class";
import { Basket } from "@/api/basket";
import REQ_URL from "@/consts/req-url";
import simpleFormDialog from "@/components/SimpleFormDialog/SimpleFormDialog";
import AdvanceInvoice from "@/components/AdvanceInvoice/AdvanceInvoice";
import {
  SettlementAccounts,
} from "@/types/settlement-account";
import { Watch } from "vue-property-decorator";
import gaussRound from "@/api/gaussRound";
import { Ofertas } from "@/api/ofertas";

@Component({
  components: {
    simpleFormDialog,
    AdvanceInvoice
  },
})
export default class BasketPage extends BasketAbstract {
  @Getter("managerInfo") managerInfo!: Manager;
  @Getter("clientProfile") clientProfile!: Client;
  @Getter("basket") basket!: Basket;
  @Getter("settlementAccounts") settlementAccounts!: SettlementAccounts;
  sending = false;
  downloadingPreliminaryBill = false;
  downloadingUnsecuredFile = false;
  showAdvanceInvoice = false;
  sendingAdvanceInvoice = false;
  showOfertasDialog = false;
  showClearBaskerDialog = false;
  showDeleteSelectedDialog = false;
  ofertas: Ofertas[] = []
  orderParams = {
    type: "waiting_for_confirmation",
    delivery: true,
    settlementAccount: undefined as any,
    contractor: "",
  };
  get comment() {
    return this.$store.getters.basketComment;
  }
  set comment(val) {
    this.$store.commit("updateBasketComment", val);
  }
  get unsecuredBasket() {
    let items = this.basket.items.filter((item) => {
      return item.selected && item.quantity > item.Наличие;
    });
    let original_total_price = gaussRound(
      items.length
        ? items.reduce((acc: number, item) => {
          return acc + item.original_line_price - item.Цена_по_факту;
        }, 0)
        : 0,
      2
    );
    return {
      token: this.basket.token,
      ID: this.basket.ID,
      original_total_price: original_total_price,
      total_price: new Intl.NumberFormat("ru", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(original_total_price),
      items: items,
    } as Basket;
  }

  get sortedBasket() {
    // $refs нереактивны: пока таблица не смонтирована, берём позиции из корзины,
    // иначе computed закеширует пустой список без зависимостей от товаров
    const filteredItems: any[] = this.$refs.basketTable &&
      (this.$refs.basketTable as any).filteredItems
      ? (this.$refs.basketTable as any).filteredItems
      : this.basket.items;
    // Экземпляр Basket, чтобы toJSON() посчитал итоги только по выбранным позициям
    const basket = Object.assign(new Basket(), {
      token: this.basket.token,
      note: this.basket.note,
      timestamp: this.basket.timestamp,
      ID: this.basket.ID,
      items: filteredItems.filter((item) => item.selected),
    });
    return {
      ...this.orderParams,
      basket: JSON.parse(JSON.stringify(basket)),
    };
  }

  clearBasket() {
    this.showClearBaskerDialog = false;
    this.$store.dispatch("clearBasket");
  }
  deleteSelectedProducts() {
    this.showDeleteSelectedDialog = false;
    this.$store.dispatch("deleteSelectedProducts");
  }
  saveBasket() {
    this.$store.dispatch("saveBasket");
  }

  async downloadPreliminaryBill() {
    try {
      this.downloadingPreliminaryBill = true;
      let data = await (
        await fetch(REQ_URL.SEND_AI, {
          method: "post",
          body: JSON.stringify({
            data: this.sortedBasket,
          }),
        })
      ).blob();
      var link = document.createElement("a");
      let downloadUrl = URL.createObjectURL(data);
      link.href = URL.createObjectURL(data);
      link.download = `предварительный_счет_${this.basket.ID}.xls`;
      document.body.append(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      this.$store.commit("modal:open", {
        type: "error",
        msg: error.message,
      });
    }
    this.downloadingPreliminaryBill = false;
  }
  async downloadUnsecuredFile() {
    try {
      this.downloadingUnsecuredFile = true;
      let data = await (
        await fetch(REQ_URL.GET_UF, {
          method: "post",
          body: JSON.stringify({
            data: this.unsecuredBasket,
          }),
        })
      ).blob();
      var link = document.createElement("a");
      let downloadUrl = URL.createObjectURL(data);
      link.href = URL.createObjectURL(data);
      link.download = `файл_необеспечки_${this.basket.ID}.xls`;
      document.body.append(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      this.$store.commit("modal:open", {
        type: "error",
        msg: error.message,
      });
    }
    this.downloadingUnsecuredFile = false;
  }
  async getOfertas() {
    this.showOfertasDialog = false;

    try {
      if (!this.shouldShowDialog()) {
        return;
      }

      let data = await this.$fetch<Ofertas[]>(REQ_URL.GET_OFERTAS, {
        method: 'POST',
        body: JSON.stringify({
          basket: this.basket,
        }),
      });

      if (!data.body) return;

      let ofertas = data.body;

      const filtered = ofertas.filter((oferta) => {
        const isEmpty = !oferta.products || oferta.products.trim() === '';

        if (isEmpty && this.isOfertaViewed(oferta.id)) {
          return false;
        }

        return true;
      });

      if (filtered.length === 0) {
        this.saveDialogHideTimestamp();
        return;
      }

      this.ofertas = filtered;
      this.showOfertasDialog = true;

      filtered.forEach((oferta) => {
        if (!oferta.products || oferta.products.trim() === '') {
          this.saveViewedOferta(oferta.id);
        }
      });

    } catch (error) {
      this.showOfertasDialog = false;
    }
  }
  pluralItems(count: number): string {
    const mod10 = count % 10;
    const mod100 = count % 100;
    if (mod10 === 1 && mod100 !== 11) return `${count} товар`;
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return `${count} товара`;
    return `${count} товаров`;
  }
  async send() {
    if (this.sending) return;
    if (
      !this.orderParams.contractor &&
      this.clientProfile.contractors &&
      this.clientProfile.contractors.length
    ) {
      this.$store.commit("modal:open", {
        type: "error",
        msg: "Выберите контрагента",
      });
      return;
    }
    this.sending = true;
    this.$store.commit("modal:open", {
      type: "loading",
      msg: "Пожалуйста подождите...",
    });
    // Заказ уходит с корзиной этой вкладки, поэтому сначала она сверяется с сервером
    if (!(await this.$store.dispatch("verifyBasketBeforeOrder"))) {
      this.sending = false;
      this.$store.commit("modal:open", {
        type: "warning",
        msg: "Корзину изменили с другого устройства. Проверьте её и оформите заказ ещё раз.",
      });
      return;
    }
    // Пока заказ оформляется, корзина не сверяется с сервером: после заказа верна корзина этой вкладки
    this.$store.dispatch("setBasketOrdering", true);
    // В заказ уходят эти позиции, они же потом удаляются из корзины
    const ordered = this.$store.getters.selectedBasketProducts;
    const orderedCodes: string[] = ordered.map((item: { Артикул: string }) => item.Артикул);
    try {
      // Экземпляр Basket, чтобы toJSON() добавил итоги (total_price, total_price_pofaktu и т.д.) по выбранным позициям
      const orderBasket = Object.assign(new Basket(), {
        token: this.basket.token,
        note: this.basket.note,
        timestamp: this.basket.timestamp,
        ID: this.basket.ID,
        items: ordered,
      });
      let data = await this.$fetch(REQ_URL.PLACE_AN_ORDER, {
        method: "POST",
        // Без офлайн-режима сервис-воркер не откладывает заказ: при обрыве сети корзина остаётся на месте
        headers: this.$store.getters.offlineMode ? { "X-Offline-Mode": "1" } : {},
        body: JSON.stringify({
          ...this.orderParams,
          basket: orderBasket,
        }),
      });
      this.$store.commit("modal:close");
      if (data.msg) {
        this.resetOrderForm();
        await this.$store.dispatch("deleteSelectedProducts", orderedCodes);
        const remaining = this.$store.getters.basketProductCount;
        this.$store.commit("modal:close");
        if (!remaining) {
          this.$store.commit("modal:open", { type: "success", msg: data.msg });
          this.$router.push("/");
        } else {
          this.$store.dispatch("snackbar:after:open", {
            type: "success",
            msg: `Заказ оформлен, ${this.pluralItems(remaining)} осталось в корзине`,
          });
        }
      }
    } catch (error) {
      if (error.code === 901) {
        this.resetOrderForm();
        await this.$store.dispatch("deleteSelectedProducts", orderedCodes);
        const remaining = this.$store.getters.basketProductCount;
        this.$store.commit("modal:close");
        if (!remaining) {
          this.$store.commit("modal:open", { type: "warning", msg: error.message });
          this.$router.push("/");
        } else {
          this.$store.dispatch("snackbar:after:open", {
            type: "warning",
            msg: `Заказ оформлен, ${this.pluralItems(remaining)} осталось в корзине`,
          });
        }
      } else
        this.$store.commit("modal:open", {
          type: "error",
          msg: error.message,
        });
    } finally {
      this.$store.dispatch("setBasketOrdering", false);
    }
    this.sending = false;
  }
  // Сброс параметров заказа после оформления. Комментарий и ID обновляются до
  // deleteSelectedProducts, чтобы saveBasket отправил корзину уже с ними
  resetOrderForm() {
    this.$store.commit("renewBasketID");
    this.comment = "";
    this.orderParams.type = "waiting_for_confirmation";
    this.orderParams.delivery = true;
    this.orderParams.contractor = "";
    this.saveContractor("");
  }
  @Watch("settlementAccounts") onSetSettlementAccounts() {
    if (!this.orderParams.settlementAccount)
      this.orderParams.settlementAccount = this.settlementAccounts[0].value;
  }
  saveContractor(contractorID: string) {
    let contractorString = localStorage.getItem("conractor");
    if (contractorString) {
      let contractorMap: { [key: string]: string } = JSON.parse(
        contractorString
      );
      contractorMap[this.clientProfile.c1code] = contractorID;
      localStorage.setItem("conractor", JSON.stringify(contractorMap));
    } else {
      localStorage.setItem(
        "conractor",
        JSON.stringify({
          [this.clientProfile.c1code]: contractorID,
        })
      );
    }
  }
  async mounted() {
    if (this.$store.state.profile.profileType === 'client') {
      await this.getOfertas();
    }

    let contractorString = localStorage.getItem("conractor");
    if (contractorString) {
      let contractorMap: { [key: string]: string } = JSON.parse(
        contractorString
      );
      this.orderParams.contractor = contractorMap[this.clientProfile.c1code]
        ? contractorMap[this.clientProfile.c1code]
        : "";
    }
    this.orderParams.settlementAccount =
      this.settlementAccounts && this.settlementAccounts.length
        ? this.settlementAccounts[0].value
        : "";
  }
  saveViewedOferta(id: string) {
    const data = JSON.parse(localStorage.getItem('viewedOfertas') || '{}');
    data[id] = Date.now();
    localStorage.setItem('viewedOfertas', JSON.stringify(data));
  }

  isOfertaViewed(id: string): boolean {
    const data = JSON.parse(localStorage.getItem('viewedOfertas') || '{}');
    if (!data[id]) return false;

    const dayMs = 24 * 60 * 60 * 1000;

    return Date.now() - data[id] < dayMs;
  }

  saveDialogHideTimestamp() {
    localStorage.setItem('ofertasDialogHidden', Date.now().toString());
  }

  shouldShowDialog(): boolean {
    const ts = localStorage.getItem('ofertasDialogHidden');
    if (!ts) return true;

    const dayMs = 24 * 60 * 60 * 1000;
    return Date.now() - Number(ts) >= dayMs;
  }
}
